// extracted by mini-css-extract-plugin
module.exports = {"button":"vocal-remove-button_button__q3EAT"};